import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { trackBookCallClick, trackNavigationClick } from '../lib/analytics';

const navigation = [
  { name: 'WORK WITH ME', href: '/work-with-me' },
  { name: 'ABOUT ME', href: '/about' },
  { name: 'BLOG', href: '/blog' },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (item, menuLocation) => {
    trackNavigationClick({
      label: item.name,
      href: item.href,
      menuLocation
    });
  };

  const handleBookCallClick = (menuLocation) => {
    trackBookCallClick({
      source: `header_${menuLocation}`,
      href: 'https://cal.com/seda-elibol/chemistry-call',
      placement: menuLocation
    });
  };

  return (
    <header className="bg-white shadow-sm">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
        <Link to="/" className="-m-1.5 p-1.5">
          <span className="text-3xl font-serif italic text-primary">Seda Elibol</span>
        </Link>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-6 lg:items-center">
          {navigation.map((item) => (
            <Link 
              key={item.name} 
              to={item.href} 
              className="text-primary font-semibold tracking-wide hover:text-secondary transition-colors"
              onClick={() => handleNavClick(item, 'desktop')}
            >
              {item.name}
            </Link>
          ))}
          <Link 
            to="https://cal.com/seda-elibol/chemistry-call"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-accent px-6 py-2 text-white font-semibold tracking-wide hover:bg-highlight hover:text-primary transition"
            onClick={() => handleBookCallClick('desktop')}
          >
            BOOK A CALL
          </Link>
        </div>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="text-3xl font-serif italic text-primary">Seda Elibol</span>
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                  to={item.href}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-primary hover:bg-gray-50"
                  onClick={() => {
                    handleNavClick(item, 'mobile');
                    setMobileMenuOpen(false);
                  }}
                >
                  {item.name}
                </Link>
                ))}
              </div>
              <div className="py-6">
                <Link
                  to="https://cal.com/seda-elibol/chemistry-call"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-primary hover:bg-gray-50"
                  onClick={() => {
                    handleBookCallClick('mobile');
                    setMobileMenuOpen(false);
                  }}
                >
                  BOOK A CALL
                </Link>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
};

export default Header; 
